import type { IExercise } from '../exercises';

export const KAISHENG_EPISODE_03_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-ksw-collection-03-01",
    "name": "热身_泡沫轴松解_屁股",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "hip-leg",
    "tips": ["坐泡沫轴上，侧偏臀部滚动", "松解臀大肌和臀中肌，1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/29f9dbca0edae8a85404a604.mp4",
    "videoUrl": "/media/collections-20261008/videos/5b501af9e16f17d3d5f2ba80.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-02",
    "name": "热身_泡沫轴松解_大腿",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "hip-leg",
    "tips": ["俯卧，泡沫轴放大腿前侧", "股四头肌全面滚动松解，1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/fa552987ba99b70f41040f6d.mp4",
    "videoUrl": "/media/collections-20261008/videos/4fe57d6ab8da2c23a8e2b13f.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-03",
    "name": "热身_泡沫轴松解_小腿",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "hip-leg",
    "tips": ["泡沫轴放小腿下方，缓慢滚动", "找到酸痛点停留 20-30 秒"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/b7cc303e792271f2287716df.mp4",
    "videoUrl": "/media/collections-20261008/videos/2d4705c3f0df591ef8f9a570.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-04",
    "name": "热身_泡沫轴松解_胫骨前肌",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "hip-leg",
    "tips": ["小腿前侧胫骨前肌放泡沫轴上", "缓慢滚动，放松胫骨前肌"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/0a9d6ffc32e299db7cc04758.mp4",
    "videoUrl": "/media/collections-20261008/videos/a48197a9ffe4c46332363907.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-05",
    "name": "热身_泡沫轴松解_阔筋膜张肌",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "hip-leg",
    "tips": ["侧卧，泡沫轴放髋外侧阔筋膜张肌", "缓慢滚动，紧张点停留呼吸"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/f35e72a387f8630f3c98adc6.mp4",
    "videoUrl": "/media/collections-20261008/videos/00cdc46804f951ea0618cc31.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-06",
    "name": "热身_动态青蛙趴",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["蛙式下蹲+动态弹动，打开髋内收", "膝盖打开对准脚尖，重心下沉"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/f25b9de5d2a73c10609f8e8e.mp4",
    "videoUrl": "/media/collections-20261008/videos/20bd36de3064509e780b748d.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-07",
    "name": "热身_伟大者伸展",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "每侧5",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/collections-20261008/demos/a673952c778e8c6f06e640c6.mp4",
    "videoUrl": "/media/collections-20261008/videos/954cc13854d495b32e909152.mp4",
    "source": "凯圣王合集 · 第3期",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-08",
    "name": "热身_髋关节9090",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["坐姿两腿各 90°，身体前后倾", "打开髋内旋和外旋活动度，每侧各 10 次"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/8120106d06cfe15c463fca72.mp4",
    "videoUrl": "/media/collections-20261008/videos/590d6b3dc033331640ed7d37.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-09",
    "name": "热身_脚踝激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["脚踝做环绕+提踵+内外翻", "充分活动踝关节，提升深蹲稳定性"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/bd72537b0174e02b50a648a6.mp4",
    "videoUrl": "/media/collections-20261008/videos/9ac12b5cb3c1fe3a2618c310.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-10",
    "name": "单腿硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/0690d7009bbb5124f4e9b234.mp4",
    "videoUrl": "/media/collections-20261008/videos/5a047f8b65d30e5d31ad926c.mp4",
    "source": "凯圣王合集 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-11",
    "name": "单腿保加利亚蹲",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "quads-glutes",
    "tips": ["后脚高架在凳上，前腿下蹲", "膝盖对准脚尖，重心在前脚脚跟"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/ec953d6e3b0ad890ddb1868b.mp4",
    "videoUrl": "/media/collections-20261008/videos/f2f7045d21a2f3f8ab4d5520.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-12",
    "name": "高脚杯深蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/80d09ed4d9412c1542de0256.mp4",
    "videoUrl": "/media/collections-20261008/videos/bc32906c90b01531d7f66645.mp4",
    "source": "凯圣王合集 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-13",
    "name": "杠铃罗马尼亚硬拉",
    "bodyPart": "legs",
    "equipment": "barbell",
    "subCategory": "hamstrings-glutes",
    "tips": ["髋部后推，杠铃沿大腿前侧下放", "感受腘绳肌强烈拉伸，臀部发力拉起"],
    "sets": 3,
    "reps": "15",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/ca2bca948dfc988e4f6d1cec.mp4",
    "videoUrl": "/media/collections-20261008/videos/8488df52c862ff19bfec5f5a.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-03-14",
    "name": "山羊挺身",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "lower-back",
    "tips": ["大腿前侧贴垫，髋部折叠下俯", "起身时感受下背和臀部收紧，不超伸"],
    "sets": 3,
    "reps": "8",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "intermediate",
    "targetMuscles": ["竖脊肌", "下背部肌群"],
    "source": "凯圣王合集 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/d51a89ec319abeef491da778.mp4",
    "videoUrl": "/media/collections-20261008/videos/d02234b4d9d43adc042dc942.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
